import { Typography } from "@atoms";
import CalendarIcon from "@assets/icons/calendar.svg";
import React, { memo } from "react";
import { CandleAllTimeWrapper } from "../storyFace.styles";
import { useTranslation } from "react-i18next";
import { ICandle } from "../storyFace.types";
import { getRemainingTimeString } from "./helpers";

const CandleTimeLeft = memo(({ candleCount }: { candleCount: ICandle[] }) => {
  const { t } = useTranslation();

  return (
    <CandleAllTimeWrapper>
      <Typography style={{ color: "#C6A691" }}>
        {t("totalTime")}
      </Typography>
      <Typography
        as="h4"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <img src={CalendarIcon} alt="calendar" />
        {getRemainingTimeString(candleCount, t)}
      </Typography>
    </CandleAllTimeWrapper>
  );
});

export default CandleTimeLeft;
